import { render, staticRenderFns } from "./GanttsCombinados.vue?vue&type=template&id=0b4ac7bb&scoped=true&"
import script from "./GanttsCombinados.vue?vue&type=script&lang=js&"
export * from "./GanttsCombinados.vue?vue&type=script&lang=js&"
import style0 from "./GanttsCombinados.vue?vue&type=style&index=0&id=0b4ac7bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4ac7bb",
  null
  
)

export default component.exports